import styled from 'styled-components';

export const ProfileContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: var(--primary);
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  margin-bottom: 2rem;

  &:hover {
    text-decoration: underline;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ProfileCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const ProfileHeader = styled.div`
  background: var(--primary);
  color: white;
  padding: 2rem;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const PlayerImage = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid white;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    margin: 0 auto;
    width: 150px;
    height: 150px;
  }
`;

export const PlayerInfoStyled = styled.div`
  h1 {
    margin: 0;
    font-size: 2.5rem;
    display: flex;
    align-items: center;
    gap: 1rem;

    span {
      font-size: 1.5rem;
      opacity: 0.8;
    }
  }

  a {
    color: var(--blue);
  }

  .position {
    font-size: 1.25rem;
    opacity: 0.8;
    margin-top: 0.5rem;
  }

  @media (max-width: 768px) {
    h1 {
      justify-content: center;
      font-size: 2rem;
    }
  }
`;

export const ProfileContent = styled.div`
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoSection = styled.div`
  h2 {
    color: var(--primary);
    margin: 0 0 1rem 0;
    font-size: 1.5rem;
  }
  
  @media (max-width: 768px) {
    overflow-x: hidden;
    width: 100%;
  }
`;

export const SponsorImage = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  
  img {
    max-width: 250px;
    max-height: 150px;
    object-fit: contain;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem 2rem;

  .value a {
    color: var(--primary);
    text-decoration: underline;
    
    &:hover {
        opacity: 0.8;
    }
  }
 
  .label {
    font-weight: 600;
    color: var(--gray);
  }
  
  .value {
    color: var(--text);
  }
`;

export const StatsTable = styled.div`
  display: grid;
  gap: 0;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    overflow-x: auto;
    width: 100%;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
  }
`;

export const StatHeader = styled.div<{ isGoalie?: boolean }>`
  display: grid;
  grid-template-columns: ${props => props.isGoalie 
    ? '1.2fr repeat(6, 1fr)' 
    : '1.2fr repeat(6, 1fr)'};
  background: var(--primary);
  color: white;
  font-weight: bold;
  text-align: center;
  
  @media (max-width: 768px) {
    grid-template-columns: ${props => props.isGoalie 
      ? '80px repeat(6, 50px)' 
      : '80px repeat(6, 50px)'};
    font-size: 0.75rem;
    width: ${props => props.isGoalie ? '380px' : '380px'};
  }
`;

export const StatRow = styled.div<{ isGoalie?: boolean }>`
  display: grid;
  grid-template-columns: ${props => props.isGoalie 
    ? '1.2fr repeat(6, 1fr)' 
    : '1.2fr repeat(6, 1fr)'};
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: var(--primary);
  
  &:nth-child(even) {
    background: rgba(0, 0, 0, 0.05);
  }
  
  &:nth-child(odd):not(:first-child) {
    background: white;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: ${props => props.isGoalie 
      ? '80px repeat(6, 50px)' 
      : '80px repeat(6, 50px)'};
    font-size: 0.85rem;
    width: ${props => props.isGoalie ? '380px' : '380px'};
  }
`;

export const StatCell = styled.div`
  padding: 0.75rem 0.5rem;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:last-child {
    border-right: none;
  }
  
  &:first-child {
    font-weight: 600;
    text-align: left;
    justify-content: flex-start;
    padding-left: 1rem;
  }
  
  @media (max-width: 768px) {
    padding: 0.5rem 0.2rem;
    
    &:first-child {
      padding-left: 0.5rem;
      font-size: 0.75rem;
    }
  }
`; 